import { useState } from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

export const useFunLoading = (loadingPhrases: string[]) => {
  const [counter, setCounter] = useState(0)
  const activePhrase = loadingPhrases[counter]

  useUnsafeEffect(() => {
    setCounter(0)
  }, [])

  useUnsafeEffect(() => {
    const interval = setInterval(() => {
      if (counter === loadingPhrases.length - 1) setCounter(3)
      if (counter < loadingPhrases.length - 1) setCounter(counter + 1)
    }, 4000)

    return () => {
      clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter])

  return activePhrase
}
